export default "__VITE_ASSET__DiWfDD0K__"